/**
 * Stale SPA shell / hashed asset failures after deploy (or transient CDN blips).
 * Matches Vite/webpack chunk CSS preload and dynamic import errors.
 */
const isStaleClientAssetErrorMessage = (message: string): boolean =>
  /Loading chunk [\d]+ failed/i.test(message) ||
  /ChunkLoadError/i.test(message) ||
  /Unexpected token '<'/i.test(message) ||
  /Unable to preload CSS for /i.test(message) ||
  /Failed to fetch dynamically imported module/i.test(message) ||
  /error loading dynamically imported module/i.test(message);

const getErrorMessage = (error: unknown): string => {
  if (error == null) {
    return '';
  }

  if (typeof (error as { message?: unknown }).message === 'string') {
    return (error as { message: string }).message;
  }

  return String(error);
};

const isStaleClientAssetError = (error: unknown): boolean => {
  const message = getErrorMessage(error);
  return message.length > 0 && isStaleClientAssetErrorMessage(message);
};

export { getErrorMessage, isStaleClientAssetError, isStaleClientAssetErrorMessage };
